import { ApckPropertyTable } from '../common/property_table';
import { ApckModalCredentialSelect } from '../credential_manager/cred_import';

export const ApckGoScriptVariables = {
    components: {
        'apck-property-table': ApckPropertyTable,
    },
    props: {
        activeScript: {
            type: Object,
            require: true,
        },
        enableCredentialService: {
            type: Boolean,
            default: false,
        },
        protectedKeys: {
            type: Array,
        },
    },
    data() {
        return {
            variablesRegex: new RegExp('[^\\w]', 'g'),
            propertiesFields: [
                // is_property - The key cannot be changed
                {
                    key: 'login_url',
                    value: '',
                    type: 'text',
                    is_property: true,
                    edit: false,
                },
                {
                    key: 'username',
                    value: '',
                    type: 'text',
                    is_property: true,
                    edit: false,
                },
                {
                    key: 'password',
                    value: '',
                    type: 'password',
                    is_property: true,
                    edit: false,
                },
            ],
        };
    },
    methods: {
        clickEditVariable(item) {
            if (this.enableCredentialService && this.protectedKeys.includes(item.key)) {
                this.openCredential();
                return true;
            }
            return false;
        },
        openCredential() {
            let src = '/credman/credentials?type=USERNAME_PASSWORD';
            this.$lightbox.open({
                title: 'Select a credential',
                component: ApckModalCredentialSelect,
                bind: {
                    src: src,
                    skip_password_check: this.skip_password_check,
                    not_shared: this.not_shared,
                    cred_type: 'USERNAME_PASSWORD',
                },
                on: {
                    select: this.selectCredential,
                },
                size: 'wide',
            });
        },
        selectCredential: function (rec) {
            if (rec.get('type') === 'USERNAME_PASSWORD' || rec.get('type') === 'EMAIL_PASSWORD') {
                this.$refs.variablesTable.addOrUpdateProperty({
                    key: 'username',
                    values: {
                        value: { uuid: rec.get('uuid'), description: rec.get('description') },
                        type: 'credential',
                    },
                });
                this.$refs.variablesTable.addOrUpdateProperty({
                    key: 'password',
                    values: {
                        value: { uuid: rec.get('uuid'), description: rec.get('description') },
                        type: 'credential',
                    },
                });
            }
        },
    },
    template: `
        <apck-property-table
            ref="variablesTable"
            v-model="activeScript.variables"
            :fields="propertiesFields"
            :key-regex="variablesRegex"
            :click-edit-handler="clickEditVariable"
            confirmation-message="Are you sure you want to delete the variable"
            confirmation-empty-message="Are you sure you want to delete the unnamed variable property?"
            confirmation-item="variable property"
            :is-bulk-mode="false"
            :enable-credential-service="enableCredentialService"
        >
            <apck-button
                v-if="enableCredentialService"
                slot="actionButtons"
                title="Import Credential"
                value="Import Credential"
                icon="fa-folder-open"
                class="btn-property"
                :handler="openCredential"
            />
        </apck-property-table>
    `,
};

export const ApckGoScriptNetworkCredentials = {
    props: {
        activeScript: {
            type: Object,
            require: true,
        },
    },
    template: `
        <apck-tabs>
            <apck-tab title="Basic" :active="true">
                <apck-field>
                    <apck-credential-import
                        v-model="activeScript.basic_credential_id"
                        select-button-class="btn-property"
                        remove-button-class="btn-property-negative"
                    />
                </apck-field>
            </apck-tab>
            <apck-tab title="Digest" :active="false">
                <apck-field>
                    <apck-credential-import
                        v-model="activeScript.digest_credential_id"
                        select-button-class="btn-property"
                        remove-button-class="btn-property-negative"
                    />
                </apck-field>
            </apck-tab>
            <apck-tab title="NTLM" :active="false">
                <apck-field>
                    <apck-credential-import
                        v-model="activeScript.ntlm_credential_id"
                        select-button-class="btn-property"
                        remove-button-class="btn-property-negative"
                    />
                </apck-field>
            </apck-tab>

        </apck-tabs>
    `,
};
